if($('.subcategories').length){
    $('.subcategories li a img').each(function(){
        $(this).attr('src', $(this).attr('src').replace('thumb', 'orig'))
    })
}

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customSorting()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customSorting()
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customSorting()
});
$(document).ready(function(){
    customSorting()
})

function customSorting(){
    function getVariantText(count) {
        if (count === 1) {
            return 'produkt byl nalezen';
        } else if (count >= 2 && count <= 4) {
            return 'produkty byly nalezeny';
        } else {
            return 'produktů bylo nalezeno';
        }
    }
    var productsCount = getVariantText(parseInt($('#category-header>div:not(".customSorting") strong').text().trim().replace(/ /g, '')));
    $('#category-header').prepend('<div class="customSorting"><span class="sortingDisplay"></span><span class="numberOfProducts">'+$('#category-header>div:not(".customSorting") strong').text()+' '+productsCount+'</span><div class="produtsDisplay"><span class="displayList">Náhled seznam</span><span class="displayTile">Náhled dlaždice</span></div></div>')
    $('.sortingDisplay').text($('#category-header input[type=radio]:checked+label').text())
    $(document).on('click', '.sortingDisplay', function(){
        $('#category-header form').toggleClass('opentIt')
    })
    display_view = localStorage.zobrazeni_produktu
    if(display_view == 'TileView'){
        $('body').addClass('TileView')
        $('.displayTile').addClass('active')
    }
    else if(display_view == 'ListView'){
        $('body').addClass('ListView')
        $('.displayList').addClass('active')
    }
    else{
        $('body').addClass('TileView')
        $('.displayTile').addClass('active')
    }
    $('.displayList').on('click', function(){
        $('.displayTile').removeClass('active')
        $(this).addClass('active')
        $('body').addClass('ListView')
        $('body').removeClass('TileView')
        localStorage.zobrazeni_produktu = 'ListView';
    
    })
    $('.displayTile').on('click', function(){
        $('.displayList').removeClass('active')
        $(this).addClass('active')
        $('body').addClass('TileView')
        $('body').removeClass('ListView')
        localStorage.zobrazeni_produktu = 'TileView';
    })
}